import { useState } from 'react';

import styled from 'styled-components';

import { colors } from 'chime-ui/system';

import DisclosureModalBottomSheet from './Modals/DisclosureModalBottomSheet';

export default function ShowDisclosureModal() {
  const [showModal, setShowModal] = useState(false);
  const closeBottomSheet = () => {
    setShowModal(false);
  };

  return (
    <>
      <SeeLegalDisclosuresSmallText>
        {'See '}
        <SeeLegalDisclosuresButton
          type="button"
          onClick={() => setShowModal(true)}
        >
          legal disclosures
        </SeeLegalDisclosuresButton>
      </SeeLegalDisclosuresSmallText>
      {showModal && (
        <DisclosureModalBottomSheet closeBottomSheet={closeBottomSheet} />
      )}
    </>
  );
}

export const SmallText = styled.p`
  font-size: 0.75rem;
  color: ${colors['content-secondary']};
  text-align: center;
`;

export const SeeLegalDisclosuresSmallText = styled(SmallText)`
  margin-top: 24px;
  margin-bottom: 24px;
`;

const SeeLegalDisclosuresButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
  text-decoration: underline;
`;
